module.exports = __webpack_public_path__ + "img/Suzuki-dragon.6082350e.jpg";